import { Clerk } from '@clerk/clerk-js';
import store from '@/store';
import { storage } from '@/utils/storage';
import { ScanDataKey, AccessTokenKey, RefreshTokenKey } from '@/enum';
// import { joinPaths } from '@/utils/join-path';
import { getClerkPublicKey, refreshAccessToken } from '@/api/base';
import { zhCN } from '@clerk/localizations';
import { createPortal } from '@/utils/create-portal';
import SignIn from '@/components/login-modal.vue';
import EventBus from '@/lib/events';
import UserAvatar from '@/components/user-avatar.vue';
import { getUserInfo, getDeployType } from '@/api/base';

// const refreshCookieAccessToken = () => {
//   // 读取 cookie 中的 __session
//   // 将 __session 的 value 写入到所有子域名可访问的 access_token cookie 中
//   const domain = document.location.hostname;
//   const subdomain = domain.startsWith('localhost') ? domain : `.${domain}`;
//   const session = document.cookie.split(';').find((item) => item.trim().startsWith('__session'));
//   if (session) {
//     const accessToken = session.split('=')[1];
//     document.cookie = `access_token=${accessToken}; path=/;domain=${subdomain}`;
//   }

//   setTimeout(() => {
//     refreshCookieAccessToken();
//   }, 1000);
// };

async function initClerk() {
  // refreshCookieAccessToken();

  const { publishableKey: PUBLISHABLE_KEY } = await getClerkPublicKey();

  if (!PUBLISHABLE_KEY) {
    throw new Error('Missing Publishable Key');
  }

  const clerk = new Clerk(PUBLISHABLE_KEY, {
    localization: zhCN,
  });

  await clerk.load();

  if (!clerk.session) {
    return clerk;
  }

  const token = await clerk.session.getToken();
  const user = clerk.user;

  store.dispatch('user/setAccessToken', token);
  store.dispatch('user/setUser', user);

  clerk.addListener((emission) => {
    if (!emission.session) {
      store.dispatch('user/setAccessToken', '');
      store.dispatch('user/setUser', {});
      storage.remove(ScanDataKey);
    } else {
      emission.session.getToken().then((token) => {
        store.dispatch('user/setAccessToken', token);
        document.cookie = `access_token=${token}; path=/;`;
      });
      store.dispatch('user/setUser', emission.user);
    }
  });

  return clerk;
}

async function initAuth() {
  const accessToken = storage.get(AccessTokenKey);
  const refreshToken = storage.get(RefreshTokenKey);
  let interval = 50 * 1000;
  let timestamp = null;

  const updateToken = (accessToken, refreshToken, expiresIn, refreshExpiresIn, forceChangePwd) => {
    storage.set(AccessTokenKey, accessToken, expiresIn * 1000);
    storage.set(RefreshTokenKey, refreshToken, refreshExpiresIn * 1000);

    store.dispatch('user/setAccessToken', accessToken);
    store.dispatch('user/setForceChangePwd', forceChangePwd);
    setTimeout(() => {
      store.dispatch('user/updateAvailableTokens');
    }, 1000);
  };

  const startRefreshToken = async (immediate = false) => {
    const refreshTokenCallback = async () => {
      const refreshToken = storage.get(RefreshTokenKey);
      const response = await refreshAccessToken({ refreshToken: refreshToken });
      updateToken(response.accessToken, response.refreshToken, response.expiresIn, response.refreshExpiresIn, response.forceChangePwd);

      timestamp = setTimeout(refreshTokenCallback, interval);
    };

    if (immediate) {
      timestamp && clearTimeout(timestamp);
      await refreshTokenCallback();
    } else {
      timestamp = setTimeout(refreshTokenCallback, interval);
    }
  };

  EventBus.$on('login-success', (data) => {
    const { accessToken, refreshToken, expiresIn, refreshExpiresIn, forceChangePwd } = data;

    updateToken(accessToken, refreshToken, expiresIn, refreshExpiresIn, forceChangePwd);

    if (forceChangePwd) {
      window.location.href = '/setting/first-login';
    }

    startRefreshToken();
  });

  EventBus.$on('logout', () => {
    storage.remove(AccessTokenKey);
    storage.remove(RefreshTokenKey);
    storage.remove(ScanDataKey);
    store.dispatch('user/setAccessToken', '');
    store.dispatch('user/setUser', {});
    window.location.reload();
  });

  if (refreshToken) {
    if (accessToken) {
      store.dispatch('user/setAccessToken', accessToken);
      // getUserInfo().then((res) => {
      //   store.dispatch('user/setUser', {
      //     fullName: res.username,
      //   });
      // });
    }

    await startRefreshToken(true);
  }

  const session = {
    getToken() {
      return Promise.resolve(storage.get(AccessTokenKey));
    },
  };
  let loginInstance = null;

  return {
    session,
    mountSignIn() {
      loginInstance = createPortal(SignIn, '#app');
    },
    unmountSignUp() {
      if (loginInstance) {
        loginInstance.destroy();
        loginInstance = null;
      }
    },
    mountUserButton(el) {
      const isSaas = store.getters['common/isSaas'];
      getUserInfo().then((res) => {
        store.dispatch('user/setUser', {
          fullName: res.username,
        });
        createPortal(UserAvatar, el, { user: store.getters['user/user'], isSaas });
      });
    },
  };
}

export async function init() {
  const result = await getDeployType();
  store.dispatch('common/setDeployType', result.deployType);

  if (store.getters['common/isSaas']) {
    return initClerk();
  }

  return initAuth();
}
